var _style, _path, _path2, _polygon, _polygon2, _polygon3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoX12(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 100",
    style: {
      enableBackground: "new 0 0 200 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:#363640;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.4915,
    y1: 91.2461,
    x2: -90.367,
    y2: -32.118,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27A3DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6834,
    style: {
      stopColor: "#600A5F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.6,100V22.8H80.1L93.2,0.2h23.6V100H91.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.241,
    y1: 68.4482,
    x2: -80.3719,
    y2: -54.8102,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27A3DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6834,
    style: {
      stopColor: "#600A5F"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.7,82.5c2.5-2.2,6-5.3,10.5-9.2c4.5-3.9,8-6.9,10.5-9.1c2.5-2.2,5.4-4.9,8.7-8.2s5.8-6.1,7.5-8.4 c4.3-6,6.5-11.2,6.5-15.7c0-7.9-3.5-11.8-10.4-11.8c-3.3,0-6,1.2-7.9,3.5c-1.9,2.4-2.9,5.8-2.9,10.2h-22.9c0-11.1,3.2-19.5,9.6-25.2 c6.4-5.7,14.9-8.5,25.3-8.5c10.4,0,18.6,3,24.4,8.9c5.8,6,8.7,13.2,8.7,21.6c0,6.4-1.4,12-4.2,16.8c-1.7,2.8-3.1,5.1-4.3,7.1 c-1.2,1.9-3.2,4.3-6,7.2s-4.8,4.9-6.1,6.2c-1.3,1.3-3.7,3.5-7.1,6.7c-3.5,3.1-5.7,5.2-6.6,6.1h36.1V100h-69.4V82.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.7742,
    y1: 79.1625,
    x2: -85.0844,
    y2: -44.2016,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27A3DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6834,
    style: {
      stopColor: "#600A5F"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "49.7,75.6 65.1,100 88.1,100 61.7,54.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.439,
    y1: 124.1224,
    x2: -104.4196,
    y2: 0.7584,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27A3DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6834,
    style: {
      stopColor: "#600A5F"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "28.3,0.2 0.7,0.2 32.2,50.1 0.7,100 28.3,100 42,76.6 57.5,50  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.8828,
    y1: 130.0667,
    x2: -106.9759,
    y2: 6.7026,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27A3DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6834,
    style: {
      stopColor: "#600A5F"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "87.8,0.2 62.6,0.2 49.3,23.2 62,44.8  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M192.8,96.6c0-1.8,1.5-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2c0,1.8-1.4,3.2-3.2,3.2 C194.2,99.9,192.8,98.4,192.8,96.6z M193.2,96.6c0,1.5,1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0-1.6-1.3-2.8-2.8-2.8 C194.4,93.8,193.2,95,193.2,96.6z M195.9,97h-0.7v1.5h-0.5v-3.7h1.5c0.6,0,1.2,0.4,1.2,1.1c0,0.8-0.7,1.1-1,1.1l1,1.5h-0.6 L195.9,97z M195.2,95.2v1.4l1.1,0c0.4,0,0.7-0.3,0.7-0.7c0-0.4-0.3-0.7-0.7-0.7C196.3,95.2,195.2,95.2,195.2,95.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoX12);
export default __webpack_public_path__ + "static/media/logo_x12.2a8590d39d507de2ebe3e2d1f6ceac87.svg";
export { ForwardRef as ReactComponent };